<script setup>
import ModalBox from './ModalBox.vue'
import ButtonCopyToClipboard from '../Moleculas/ButtonCopyToClipboard.vue'
import FormInput from '../Atoms/FormInput.vue'
import Alert from '../Atoms/Alert.vue'
import FormButton from '../Atoms/FormButton.vue'
import { useLegacyModalBridge } from '@/composables/useLegacyModalBridge'

const MODAL_ID = 'modalGetAccessToken'

defineProps({
	accessToken: {
		type: Object,
		default: () => ({}),
	},
	modalSize: {
		type: String,
		default: 'md',
		validator(v) {
			return ['xl', 'lg', 'md', 'sm'].some((size) => size === v)
		},
	},
})

const emit = defineEmits(['modal-cancel', 'modal-dismiss'])

const { isVisible, hide } = useLegacyModalBridge(MODAL_ID)

const dismiss = () => {
	emit('modal-cancel')
	hide()
	emit('modal-dismiss')
}
</script>

<template>
	<ModalBox
		v-model="isVisible"
		:size="modalSize"
		hide-close
		header-class="!hidden"
		wrapper-classes="lg:h-auto lg:max-h-none"
		@close="dismiss"
	>
		<div class="px-6 pt-6">
			<h4 class="text-s-xl mb-6">"{{ accessToken.name }}" Access Token</h4>
			<div class="flex items-center relative !mb-4">
				<FormInput label="Access Token ID" customClasses="!pr-8" :modelValue="accessToken.accessId" readonly />
				<ButtonCopyToClipboard class="absolute right-0 bottom-px z-10" :text="accessToken.accessId" />
			</div>
			<div class="flex items-center relative mb-6">
				<FormInput label="Secret Key" customClasses="!pr-8" :modelValue="accessToken.secret" readonly />
				<ButtonCopyToClipboard class="absolute right-0 bottom-px z-10" :text="accessToken.secret" />
			</div>
			<Alert>
				We do not store the secret keys, so ensure you save them in a secure location.
			</Alert>
		</div>
		<template #footer>
			<div class="flex justify-end p-6 border-t border-surface-3">
				<FormButton type="secondary" @click="dismiss">
					Close
				</FormButton>
			</div>
		</template>
	</ModalBox>
</template>
